<template>
  <section>
    <table class="voucher-table">
      <caption>
        웨이브 이용권 표
      </caption>
      <colgroup>
        <col style="width: 230px" />
        <col />
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>
            <span class="a11y-hidden">이용권 상품 목록</span>
          </th>
          <th
            v-for="(voucher, index) in wavveVoucherList"
            :key="'wavve_voucher_head_' + index"
            scope="col"
          >
            <div>
              <span v-if="isRecommend(voucher)" class="icon icon-supplant"
                >추천</span
              >
              <span v-if="isUsed(voucher)" class="icon">이용중</span>
              <span v-if="isUpcoming(voucher)" class="icon">결제 예약</span>
              <h2 class="product-name">
                {{ getValueFn(voucher, 'product_name') }}
              </h2>
              <span
                v-if="getValueFn(voucher, 'displayamount') !== ''"
                class="before-price"
              >
                &#65510;{{
                  setNumberCommasFn(getValueFn(voucher, 'displayamount'))
                }}
              </span>
              <button
                v-for="(amountInfoData, index) in purchaseAmountInfoList(
                  voucher,
                )"
                :id="getAmountInfoValue(amountInfoData, 'productid')"
                :key="'amount_button_' + index"
                ref="purchaseButton"
                type="button"
                class="btn"
                @click="voucherPurchase(voucher, amountInfoData)"
              >
                <span class="month">
                  <span>{{
                    getAmountInfoValue(amountInfoData, 'use_day')
                  }}</span>
                  <span
                    v-if="
                      getAmountInfoValue(amountInfoData, 'discount_rate') !== ''
                    "
                    class="discount"
                    >{{
                      getAmountInfoValue(amountInfoData, 'discount_rate')
                    }}%</span
                  >
                </span>
                <span class="price">
                  <span
                    >&#65510;{{
                      setNumberCommasFn(
                        getAmountInfoValue(amountInfoData, 'amount'),
                      )
                    }}</span
                  >
                  <span
                    v-if="
                      getAmountInfoValue(amountInfoData, 'month_amount') !== ''
                    "
                    class="summary"
                  >
                    &lpar;월 &#65510;{{
                      setNumberCommasFn(
                        getAmountInfoValue(amountInfoData, 'month_amount'),
                      )
                    }}&rpar;
                  </span>
                </span>
              </button>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(voucher, index) in voucherFormatList(
            wavveVoucherList,
            bodyDescriptionList,
          )"
          :key="'voucher_info' + index"
        >
          <th scope="row">{{ voucher.title }}</th>
          <td>
            <span :class="tdClass(voucher, 'Premium')">{{
              tdText(voucher, 'Premium')
            }}</span>
          </td>
          <td>
            <span :class="tdClass(voucher, 'Standard')">{{
              tdText(voucher, 'Standard')
            }}</span>
          </td>
          <td>
            <span :class="tdClass(voucher, 'Basic')">{{
              tdText(voucher, 'Basic')
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>
<script>
  import _ from 'lodash'

  export default {
    name: 'WavveVoucherList',
    props: {
      voucherPurchaseFn: {
        type: Function,
      },
      wavveVoucherList: {
        type: Array,
      },
      bodyDescriptionList: {
        type: Array,
      },
      getValueFn: {
        type: Function,
      },
      setNumberCommasFn: {
        type: Function,
      },
    },
    methods: {
      voucherFormatList(voucherList, descriptionList) {
        return descriptionList.map((description) => {
          let voucherObj = {}
          voucherObj['title'] = _.get(description, 'title', '')
          voucherObj['type'] = _.get(description, 'type', '')
          voucherList.forEach((voucher) => {
            const concurrency = _.get(voucher, 'concurrency.0', [])
            voucherObj[_.get(concurrency, 'product_name', '')] = _.get(
              concurrency,
              [_.get(description, 'key', '')],
              '',
            )
          })
          return voucherObj
        })
      },
      tdClass(voucher, voucherName) {
        let className = ''
        if (_.get(voucher, 'type', '') === 'check') {
          className = _.get(voucher, [voucherName], '')
            ? 'icon-check'
            : 'icon-uncheck'
        }
        return className
      },
      tdText(voucher, voucherName) {
        let text = ''
        if (_.get(voucher, 'type', '') === 'check') {
          text = _.get(voucher, [voucherName], '') ? '가능' : '불가능'
        } else {
          text = _.get(voucher, [voucherName], '')
        }
        return text
      },
      isUsed(voucher) {
        return voucher?.concurrency?.[0]?.in_use ?? false
      },
      isUpcoming(voucher) {
        return voucher?.concurrency?.[0]?.is_upcoming ?? false
      },
      isRecommend(voucher) {
        return voucher?.concurrency?.[0]?.recommendation ?? false
      },
      buttonClass(productId) {
        this.$refs.purchaseButton.forEach((buttonsEl) => {
          if (buttonsEl.id === productId) {
            buttonsEl.classList.add('selected')
          } else {
            buttonsEl.classList.remove('selected')
          }
        })
      },
      voucherPurchase(voucher, product) {
        const productId = this.getAmountInfoValue(product, 'productid', '')
        const { amount, productid, displayamount } = product
        _.set(voucher, 'concurrency.0.productid', productId)
        this.buttonClass(productId)
        this.voucherPurchaseFn({ ...voucher, amount, productid, displayamount })
      },
      purchaseAmountInfoList(voucher) {
        return _.get(voucher, 'concurrency.0.purchase_amount_info_list', [])
      },
      getAmountInfoValue(AmountInfo, key) {
        return _.get(AmountInfo, key, '')
      },
    },
  }
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
